"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _AutoHeightTextArea = _interopRequireDefault(require("../../../AutoHeightTextArea"));

var ReadOnlyShot = function ReadOnlyShot(_ref) {
  var name = _ref.name,
      asset = _ref.asset,
      script = _ref.script,
      description = _ref.description,
      index = _ref.index;

  var _ref2 = asset && asset.assetFiles ? asset.assetFiles : {},
      ORIGINAL = _ref2.ORIGINAL;

  return _react.default.createElement("div", {
    className: "shot"
  }, _react.default.createElement("p", {
    className: "shot__title"
  }, _react.default.createElement("span", null, name || "Shot ".concat(index + 1))), _react.default.createElement("div", {
    className: "shot__wrapper"
  }, _react.default.createElement("div", {
    className: "shot__image-wrapper",
    style: {
      height: '169px'
    }
  }, _react.default.createElement(_uiKit.Image, {
    height: "100%",
    width: "100%",
    imageUrl: ORIGINAL ? ORIGINAL.sourceUrl : '',
    defaultIconBackground: "white",
    defaultImageIcon: asset === null ? 'brokenlink' : 'storyboard',
    defaultIconColour: "russian",
    backgroundSize: "cover"
  })), _react.default.createElement("div", {
    className: "shot__section"
  }, _react.default.createElement("div", {
    className: "shot__number-wrapper"
  }, _react.default.createElement("p", {
    className: "shot__number-text"
  }, "".concat(index + 1))), _react.default.createElement("p", {
    className: "shot__section__title"
  }, "Script"), _react.default.createElement(_AutoHeightTextArea.default, {
    disabled: true,
    className: "shot__section__text-area",
    defaultValue: script
  })), _react.default.createElement("div", {
    className: "shot__section"
  }, _react.default.createElement("p", {
    className: "shot__section__title"
  }, "Description"), _react.default.createElement(_AutoHeightTextArea.default, {
    disabled: true,
    className: "shot__section__text-area",
    defaultValue: description
  }))));
};

var _default = (0, _commonReact.withAssetSelector)(ReadOnlyShot);

exports.default = _default;